<template>
  <div class="view">
    <div class="hader">
      <p>
        <span>{{ Number(anIndex) + 1 }}</span>
        <span>[{{ TestItems.Style }}]</span>
        <span v-html="TestItems.Title"></span>
      </p>
    </div>
    <div class="main">
      <div class="main_view">
        <div v-for="(item, index) in inputArr" :key="index">
          <p>{{ index + 1 + "." }}</p>
          <template v-if="!practice">
            <el-input
              show-word-limit
              v-model="inputArr[index].value"
              :placeholder="'请输入第' + (index + 1) + '空答案'"
              maxlength="100"
              @change="saveAnswer"
            ></el-input>
          </template>
          <template v-else>
            <el-input
              show-word-limit
              v-model="inputArr[index].value"
              :placeholder="'请输入第' + (index + 1) + '空答案'"
              maxlength="100"
            ></el-input>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      inputArr: [],
    };
  },
  props: ["TestItems", "anIndex", "userAbswerArr", "practice"],
  methods: {
    // 查看有多少个小问
    strcount(str) {
      //计算字符串出现多少次,得到多少个空
      let array = str.match(/____/g);
      let count = array ? array.length : 0;
      return count;
    },
    // 保存答案
    saveAnswer(item) {
      let newarr = this.inputArr.map((item) => {
        return item.value;
      });
      // newarr = newarr.filter(item => {
      //   return item != "";
      // });
      // 填空题如果用户填写完又删掉要讲传输的答案对象给干掉
      let nullArr = newarr.filter((item) => {
        return item == "";
      });
      let type = nullArr.length == newarr.length ? true : false; // 为true代表写完又删掉空的
      const AbswerObj = {
        TestID: this.TestItems.TestID,
        ChildTableID: this.TestItems.TestID,
        Score: this.TestItems.Score,
        UserAnswer: type == true ? null : newarr.join(";"), // 填空题接收答案格式 填空第一空；填空第二空；填空第三空
        IsRight: false, // 填空、简答、解析题全部默认错误
      };
      this.$emit("userAbswer", AbswerObj);
    },
    // 回显用户刷新保存上次答案 1;2;3  ===> [{value:1},{value:2}]
    theEchoAbswer() {
      setTimeout(() => {
        this.userAbswerArr.forEach((item) => {
          if (item.TestID == this.TestItems.TestID) {
            this.TestItems.UserAnswer = item.UserAnswer;
          }
        });
        if (this.TestItems.UserAnswer !== null) {
          console.log(this.TestItems.UserAnswer);
          let newarr = this.TestItems.UserAnswer.split(";");
          this.inputArr.forEach((item, index) => {
            newarr.forEach((zitem, zindex) => {
              if (index == zindex) {
                item.value = zitem;
              }
            });
          });
        }
      }, 500);
    },
  },
  created() {
    this.strcount(this.TestItems.Title);
    for (let i = 0; i < this.strcount(this.TestItems.Title); i++) {
      let obj = {
        value: "",
      };
      this.inputArr.push(obj);
    }
    this.theEchoAbswer();
  },
};
</script>

<style lang="scss" scoped>
.hader {
  min-height: 68px;
  display: flex;
  // align-items: center;
  background: #f7f7f7;
  user-select: none;
  padding: 12px 24px;
  p {
    text-align: left;
    span {
      &:nth-child(1) {
        color: #119ce5;
        font-weight: bold;
        font-size: 150%;
        margin: 0px 14px 18px 0px;
      }
      &:nth-child(2) {
        color: #119ce5;
        font-weight: bold;
      }
    }
  }
}
.main {
  user-select: none;
  padding: 36px 30px;
  .main_view {
    border: 1px solid #ededed;
    padding: 16px;
    > div {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      p {
        margin-right: 6px;
      }
      .el-input {
        width: 90%;
        user-select: none;
      }
    }
  }
}
</style>
